import React, { useState } from 'react';

import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';

import { useForm } from 'hooks';
import validateSignup from './validateSignup';
import { verifyUserCredentialsStart } from 'redux/user/user.actions';
import useTranslation from 'hooks/useTranslation';
import InternationalMobileNumInput from 'components/InternationalMobileNumInput';
import './styles.scss';

const SignupForm = () => {
  const [isEmailValid, setIsEmailValid] = useState('');

  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const referralParam = queryParams.get('referral');

  const { getTranslation, getAppLocale } = useTranslation(['AUTH', 'COMMON']);
  const { t } = getTranslation();

  const locale = getAppLocale();
  const defaultCountryCode = locale === 'fa' ? 'ir' : 'ae';

  const handleSignup = (values) => {
    dispatch(verifyUserCredentialsStart({ ...values, setIsEmailValid }));
  };

  const handleChangeMobileInput = (value) => {
    handleChangePhoneNumber({ target: { value, name: 'mobile' } });
  };

  const {
    values,
    errors,
    handleChange,
    handleChangePhoneNumber,
    handleSubmit,
  } = useForm(validateSignup, handleSignup, {
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    password: '',
    referralCode: referralParam,
  });

  return (
    <form className='form' id='signup_form' onSubmit={handleSubmit} noValidate>
      <div className='form_control flex'>
        <input
          name='firstName'
          value={values.firstName}
          onChange={handleChange}
          className={clsx(errors.firstName && 'has-error')}
          type='text'
          placeholder={t('NAME_PLACEHOLDER')}
          id='firstName'
          autoFocus
        />
        {errors.firstName && <div className='error'>{errors.firstName}</div>}
      </div>
      <div className='form_control flex'>
        <input
          name='lastName'
          value={values.lastName}
          onChange={handleChange}
          className={clsx(errors.lastName && 'has-error')}
          type='text'
          placeholder={t('LAST_NAME_PLACEHOLDER')}
          id='lastName'
        />
        {errors.lastName && <div className='error'>{errors.lastName}</div>}
      </div>
      <div className='form_control flex email_container'>
        <input
          name='email'
          value={values.email}
          onChange={handleChange}
          className={`${
            (errors.email ||
              isEmailValid === '"email" must be a valid email') &&
            'has-error'
          }`}
          type='email'
          placeholder={t('EMAIL_PLACEHOLDER')}
          id='email'
        />
        {errors.email ? (
          <div className='error'>{errors.email}</div>
        ) : isEmailValid === '"email" must be a valid email' ? (
          <div className='error'>{t('UN_VALID_EMAIL')}</div>
        ) : null}
      </div>
      <div className='form-control flex'>
        <InternationalMobileNumInput
          value={values.mobile}
          onChangeInput={handleChangeMobileInput}
          defaultCode={defaultCountryCode}
          error={errors.mobile}
        />
        {errors.mobile && <div className='error'>{errors.mobile}</div>}
      </div>
      <div className='form_control flex'>
        <input
          name='password'
          id='password'
          value={values.password}
          onChange={handleChange}
          className={clsx(errors.password && 'has-error')}
          type='password'
          placeholder={t('PASSWORD_PLACEHOLDER')}
        />
        {errors.password && <div className='error'>{errors.password}</div>}
      </div>
      <div className='form_control flex button'>
        <input
          type='submit'
          value={t('SIGNUP_SUBMIT_BTN')}
          className='btn btn-primary'
        />
      </div>
    </form>
  );
};

export default SignupForm;
